const getNumber = (value?: string | number): number =>
  typeof value === 'number' ? value : typeof value === 'undefined' ? 0 : parseFloat(value)

export { getNumber }
